// Statisk data og fallback-indhold for Bachmann Tømrer

export const CONTACT_INFO = {
  name: "Bachmann Tømrer",
  owner: "Martin Bachmann Andersen",
  address: "Skægkærvænget 23, 8600 Silkeborg, Danmark",
  mapsUrl: "https://www.google.com/maps/place/Sk%C3%A6gk%C3%A6rv%C3%A6nget%2023,%208600%20Silkeborg,%20Danmark",
  phone: "+45 53 80 25 24",
  phoneRaw: "53802524",
  email: "martin.b.andersen@hotmail.com",
  cvr: "43859625",
  experience: "14 års erfaring"
};

export const MENU_STRUCTURE = [
  {
    label: "Forside",
    href: "/"
  },
  {
    label: "Jeg tilbyder",
    href: "#",
    children: [
      { label: "Vinduer og døre", href: "/vinduer-og-doere" },
      { label: "Forsikringsskader", href: "/forsikringsskader" },
      { label: "Carport/skur", href: "/carport-skur" },
      { label: "Gulve", href: "/gulve" },
      { label: "Køkken montage", href: "/koekken-montage" },
      { label: "Ombyg/renovering", href: "/ombyg-renovering" },
      { label: "Tagarbejde", href: "/tagarbejde-2" },
      { label: "Terrasser", href: "/terrasser" },
      { label: "Renovering af hus", href: "/renovering-af-hus" },
      { label: "Renovering", href: "/renovering" },
      { label: "Udskiftning af vinduer", href: "/udskiftning-af-vinduer" }
    ]
  },
  {
    label: "Galleri",
    href: "/galleri"
  },
  {
    label: "Profil",
    href: "/profil"
  },
  {
    label: "Kontakt",
    href: "/kontakt"
  }
];

// 301 Redirects mapping (fra gamle URL'er til nye)
export const REDIRECTS_MAP = {
  "/tagarbejde": "/tagarbejde-2",
  "/tagarbejde/": "/tagarbejde-2",
  "/tagarbejde-2/": "/tagarbejde-2",
  "/referencer": "/referencer-2",
  "/referencer/": "/referencer-2",
  "/referencer-2/": "/referencer-2",
  "/kontakt/": "/kontakt",
  "/profil/": "/profil",
  "/galleri/": "/galleri",
  "/vinduer-og-doere/": "/vinduer-og-doere",
  "/forsikringsskader/": "/forsikringsskader",
  "/carport-skur/": "/carport-skur",
  "/gulve/": "/gulve",
  "/koekken-montage/": "/koekken-montage",
  "/ombyg-renovering/": "/ombyg-renovering",
  "/terrasser/": "/terrasser",
  "/renovering-af-hus/": "/renovering-af-hus",
  "/renovering/": "/renovering",
  "/udskiftning-af-vinduer/": "/udskiftning-af-vinduer",
  "/wp-content/uploads/2025/11/image00012-scaled.jpeg": "/ombyg-renovering",
  "/wp-content/uploads/2025/11/image00020-scaled.jpeg": "/ombyg-renovering",
  "/wp-content/uploads/2025/11/image00030-scaled.jpeg": "/ombyg-renovering"
};

// Skiftende billeder til Hero-sektionen (indtil video modtages)
export const HERO_SLIDESHOW_IMAGES = [
  "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/image00043-scaled.jpeg",
  "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/image00035-scaled.jpeg",
  "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/image00041-scaled.jpeg",
  "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/image00034-scaled.jpeg"
];

// Ydelser til forsiden (Ydelseskasser)
export const SERVICES_BOXES = [
  {
    title: "Vinduer og døre",
    desc: "Kvalitetsløsninger der kombinerer æstetik, holdbarhed og energieffektivitet.",
    href: "/vinduer-og-doere",
    icon: "fa-regular fa-door-open",
    image: "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/image00038-750x1000.jpeg"
  },
  {
    title: "Forsikringsskader",
    desc: "Hurtig, effektiv udbedring og tæt samarbejde med dit forsikringsselskab.",
    href: "/forsikringsskader",
    icon: "fa-regular fa-house-crack",
    image: "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/img-6844-754x1000.jpeg"
  },
  {
    title: "Carport/skur",
    desc: "Flotte, funktionelle og holdbare carporte og skure tilpasset dit hus.",
    href: "/carport-skur",
    icon: "fa-regular fa-garage",
    image: "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/image00029-750x1000.jpeg"
  },
  {
    title: "Gulve",
    desc: "Professionel gulvlægning af trægulve, laminat og parket med præcision.",
    href: "/gulve",
    icon: "fa-regular fa-layer-group",
    image: "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/image00004-750x1000.jpeg"
  },
  {
    title: "Køkken montage",
    desc: "Professionel montering og tilpasning af dit nye drømmekøkken.",
    href: "/koekken-montage",
    icon: "fa-regular fa-sink",
    image: "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/image00010-1-750x1000.jpeg"
  },
  {
    title: "Ombyg/renovering",
    desc: "Fornyelse og modernisering af dit hjem med respekt for stil og funktion.",
    href: "/ombyg-renovering",
    icon: "fa-regular fa-hammer",
    image: "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/image00010-750x1000.jpeg"
  },
  {
    title: "Tagarbejde",
    desc: "Kvalitetsbevidst tagarbejde og tagrenovering, der forlænger tagets levetid.",
    href: "/tagarbejde-2",
    icon: "fa-regular fa-house-building",
    image: "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/img-6835-697x1000.jpeg"
  },
  {
    title: "Terrasser",
    desc: "Smukke, holdbare træterrasser skræddersyet til din have og udeliv.",
    href: "/terrasser",
    icon: "fa-regular fa-tree",
    image: "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/img-6834-752x1000.jpeg"
  },
  {
    title: "Renovering af hus",
    desc: "Totalrenovering og modernisering med fokus på solidt håndværk.",
    href: "/renovering-af-hus",
    icon: "fa-regular fa-house-chimney-window",
    image: "https://assets.auxodev.dk/assets/4308d28a-24e2-4c25-a37f-97d46b6f1512/image00059-1000x750.jpeg"
  }
];
